module.exports = __webpack_public_path__ + "static/img/crown.dd93f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/crown.png
// module id = NKti
// module chunks = 0